// =====================================
//	補收款列表 modal
//
//	@author: Gray
//	@time 2017 / 03 / 14
// =====================================

window.InifECMobileApp.directive('orderExtrafeeList', ['$rootScope', '$ngModal', '$timeout',
	function ($rootScope, $ngModal, $timeout) {

		var _dir = {};

		var controller = ['$scope', function($scope) {

            var cancel = function() {

                closeModal();
            }

            // -------------------------------
            // [private] 開啟 modal
            // -------------------------------
            var openModal = function() {

            	$ngModal.openModal('order-extrafee-list');
            }

            // -------------------------------
            // [private] 關閉 modal
            // -------------------------------
            var closeModal = function() {

            	$ngModal.closeModal('order-extrafee-list');
            }

            // --------------------------------
            // 付款
            // --------------------------------
            var confirmExtrafeePayment = function(extrafee) {

                $rootScope.$broadcast('OPEN_CONFIRM_EXTRAFEE_PAYMENT_MODAL', {
                    extrafeeid: extrafee.extrafeeid,
                    callback: function() {
                        closeModal();
                    }
                });
            }

            // --------------------------------
            // 補收款退款申請
            // --------------------------------
            var refundExtrafee = function(extrafee) {

                $rootScope.$broadcast('OPEN_CONFIRM_EXTRAFEE_REFUND_MODAL', {
                    extrafeeid: extrafee.extrafeeid,
                    callback: function() {
                        extrafee.status = 800;
                    }
                });
            }

            /*==========================
                Events
            ==========================*/            
            $scope.$on('OPEN_ORDER_EXTRAFEE_LIST_MODAL', function(event, data) {
                $scope.extraFeeList = [];
                if(data) {
                    $scope.extraFeeList = data.extraFeeList;
                    openModal();
                }
            });

            /*==========================
                Members
            ==========================*/
            $scope.extraFeeList = [];
            
            /*==========================
                Methods
            ==========================*/
            $scope.cancel = cancel;
            $scope.confirmExtrafeePayment = confirmExtrafeePayment;
            $scope.refundExtrafee = refundExtrafee;

            /*==========================
                init
            ==========================*/

		}]

		_dir.restrict = "E";
		_dir.scope = true;
		_dir.templateUrl = "mobile/partials/modal/order_extrafee_list.html";
		_dir.controller = controller;

		return _dir;
	}]
);